import React from 'react';
import styled from 'styled-components';

/* eslint-disable-next-line import/prefer-default-export */
export const VCoins = ({ size = 30 }: { size?: number }) => (
  <VCoinsImg
    src="/static/images/vcoin/vcoin.svg"
    alt="The VCoins logo"
    size={size}
  />
);

const VCoinsImg = styled.img<{ size: number }>`
  height: ${(p) => p.size || 30}px;
  width: ${(p) => p.size || 30}px;
`;
